import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { allianceDefaultFolderTemplatesManager, type IDefaultFolderTemplate } from '@inpart-io/padme-iap';

import { store } from '@/store';

const ALLIANCE_DEFAULT_FOLDER_TEMPLATE_MODULE = 'alliancedefaultfoldertemplates';

const allianceDefaultFolderTemplateModuleInstance = getDataObjectsModule<IDefaultFolderTemplate>(allianceDefaultFolderTemplatesManager, 3);
store.registerModule(ALLIANCE_DEFAULT_FOLDER_TEMPLATE_MODULE, allianceDefaultFolderTemplateModuleInstance);

export { ALLIANCE_DEFAULT_FOLDER_TEMPLATE_MODULE };
